/* ============================================================
   LEELARAV GREENS — CENTRALIZED IMAGE ASSET CONFIGURATION
   Every image on the site is fed from this single block.
   STRICT RULE: each URL is unique and used in exactly one place.
   To swap any visual, simply paste your URL next to its name.
   ============================================================ */

/* ---------- BRAND ---------- */
// <!-- INSERT LOGO_URL HERE -->
export const LOGO_URL = "/images/logo.png";

/* ---------- HERO SECTION ---------- */
// Paste ANY YouTube link below (watch / share / shorts format) and the hero
// will automatically switch from the image slider to the playing video.
// <!-- INSERT HERO_YOUTUBE_VIDEO_URL HERE (e.g. "https://www.youtube.com/watch?v=XXXX") -->
export const HERO_YOUTUBE_VIDEO_URL = "";

// <!-- INSERT HERO_SLIDE_ONE_URL HERE -->
export const HERO_SLIDE_ONE_URL = "/images/hero-twilight-drapes.jpg";
// <!-- INSERT HERO_SLIDE_TWO_URL HERE -->
export const HERO_SLIDE_TWO_URL = "/images/hero-lawn-twilight.jpg";
// <!-- INSERT HERO_SLIDE_THREE_URL HERE -->
export const HERO_SLIDE_THREE_URL = "/images/hero-red-pandal.jpg";

/* ---------- ABOUT US SECTION ---------- */
// <!-- INSERT OWNER_PROFILE_IMAGE_URL HERE -->
export const OWNER_PROFILE_IMAGE_URL = "/images/owner-paresh.jpg";

/* ---------- VENUES & ACCOMMODATIONS ---------- */
// Banquet cards are detail-only (no images) as requested.
// <!-- INSERT LUXURY_ROOM_URL HERE -->
export const LUXURY_ROOM_URL = "/images/luxury-rooms-building.jpg";

/* ---------- AMENITIES SECTION ---------- */
// <!-- INSERT AMENITY_GUEST_ROOM_URL HERE -->
export const AMENITY_GUEST_ROOM_URL = "/images/guest-rooms-night.jpg";

/* ---------- GALLERY (all unique, never reused elsewhere) ---------- */
// Royal Weddings
export const GALLERY_WEDDING_ONE_URL = "/images/wedding-pink-arches.jpg";
export const GALLERY_WEDDING_TWO_URL = "/images/wedding-white-stage.jpg";
export const GALLERY_WEDDING_THREE_URL = "/images/wedding-panel-stage.jpg";
export const GALLERY_WEDDING_FOUR_URL = "/images/wedding-outdoor-ceremony.jpg";
// Corporate Evenings
export const GALLERY_CORPORATE_ONE_URL = "/images/corporate-conference-rows.jpg";
export const GALLERY_CORPORATE_TWO_URL = "/images/corporate-evening-lounge.jpg";
export const GALLERY_CORPORATE_THREE_URL = "/images/corporate-gala-tent.jpg";
// Pre-Wedding Functions
export const GALLERY_PREWEDDING_ONE_URL = "/images/prewedding-garden-arch.jpg";
export const GALLERY_PREWEDDING_TWO_URL = "/images/prewedding-haldi-decor.jpg";
export const GALLERY_PREWEDDING_THREE_URL = "/images/prewedding-floral-backdrop.jpg";
// Night Illuminations
export const GALLERY_NIGHT_ONE_URL = "/images/night-golden-mandap.jpg";
export const GALLERY_NIGHT_TWO_URL = "/images/night-lotus-stage.jpg";
export const GALLERY_NIGHT_THREE_URL = "/images/night-entrance-aisle.jpg";
export const GALLERY_NIGHT_FOUR_URL = "/images/night-mandap-lawn.jpg";
